module.exports = __webpack_public_path__ + "img/atbotton.3640dce1.png";